module.exports = __webpack_public_path__ + "img/mobile/General/spelpaus@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/General/spelpaus@2x.png
// module id = 188
// module chunks = 0